export const START_PURCHASE_AND_PRINT_JOB = 'START_PURCHASE_AND_PRINT_JOB';
export const startPurchaseAndPrintJob = (fulfillmentPlanId, extraJobData = {}) => ({
  type: START_PURCHASE_AND_PRINT_JOB,
  fulfillmentPlanId,
  extraJobData,
});

export const PRINT_SCAN_TO_PRINT_LABEL = 'PRINT_SCAN_TO_PRINT_LABEL';
export const printTheLabel = () => ({
  type: PRINT_SCAN_TO_PRINT_LABEL,
});

export const GET_FULFILLMENTS_FOR_FULFILLMENTPLAN = 'GET_FULFILLMENTS_FOR_FULFILLMENTPLAN';
export const getFulfillmentsForFulfillmentPlan = (fulfillmentPlanId, jobId) => ({
  type: GET_FULFILLMENTS_FOR_FULFILLMENTPLAN,
  fulfillmentPlanId,
  jobId,
});

export const FINALIZE_SCAN_TO_PRINT_FULFILLMENTPLAN = 'FINALIZE_SCAN_TO_PRINT_FULFILLMENTPLAN';
export const finalizeScanToPrintFulfillmentPlan = (fulfillmentPlanId, jobId) => ({
  type: FINALIZE_SCAN_TO_PRINT_FULFILLMENTPLAN,
  fulfillmentPlanId,
  jobId,
});

export const CREATE_LABEL_FOR_SCAN_TO_PRINT = 'CREATE_LABEL_FOR_SCAN_TO_PRINT';
export const createLabelForScanToPrint = (fulfillmentPlanId, jobId) => ({
  type: CREATE_LABEL_FOR_SCAN_TO_PRINT,
  fulfillmentPlanId,
  jobId,
});

export const GENERIC_ERROR_HANDLING_FOR_SCAN_TO_PRINT = 'GENERIC_ERROR_HANDLING_FOR_SCAN_TO_PRINT';
export const genericErrorHandlingForScanToPrint = (errors, batchId, fulfillmentPlanId) => ({
  type: GENERIC_ERROR_HANDLING_FOR_SCAN_TO_PRINT,
  errors,
  batchId,
  fulfillmentPlanId,
});

export const PRINT_SCAN_TO_PRINT_LABEL_REQUEST = 'PRINT_SCAN_TO_PRINT_LABEL_REQUEST';
export const printScanToPrintLabelRequest = (printJob, jobId) => ({
  type: PRINT_SCAN_TO_PRINT_LABEL_REQUEST,
  printJob,
  jobId,
});

export const LABEL_SUCCESSFULLY_CREATED_FOR_SCAN_TO_PRINT = 'LABEL_SUCCESSFULLY_CREATED_FOR_SCAN_TO_PRINT';
export const labelSuccessfullyCreatedForScanToPrint = () => ({
  type: LABEL_SUCCESSFULLY_CREATED_FOR_SCAN_TO_PRINT,
});
